import useSWR from "swr";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";

export const useActivityDuration = (
  corporateId: string | number,
  loId?: string | number,
): { activityDuration?: number; activityMaxParticipants?: number } => {
  const url =
    corporateId && loId
      ? `${ServicesURL.getActivities.replace(
          ":idCorporate",
          String(corporateId),
        )}/${loId}`
      : null;

  const { data } = useSWR(url, (u: string) => fetcher<any>(u, MethodType.GET));

  return {
    activityDuration:
      typeof data?.duration === "number" ? data.duration : undefined,
    activityMaxParticipants:
      typeof data?.max_partecipant === "number"
        ? data.max_partecipant
        : undefined,
  };
};
